import { Navigate } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { Loading2 } from 'components/Loading2/Loading2'
import { ViewIsometry } from './View.Isometry'

// Lazy load all route components to reduce initial bundle
const ViewGallery   = lazy(() => import('pages/View.Gallery').then(m => ({ default: m.ViewGallery })))
const ViewDownloads = lazy(() => import('pages/View.Downloads').then(m => ({ default: m.ViewDownloads })))
const ViewList      = lazy(() => import('pages/View.List').then(m => ({ default: m.ViewList })))
const ViewCompare   = lazy(() => import('pages/View.Compare').then(m => ({ default: m.ViewCompare })))
const ViewFavorites = lazy(() => import('pages/View.Favorites').then(m => ({ default: m.ViewFavorites })))
const ViewUnit      = lazy(() => import('pages/View.Unit').then(m => ({ default: m.ViewUnit })))
const Maintenance   = lazy(() => import('components/ErrorsPage/Maintenance').then(m => ({ default: m.Maintenance })))
const InactivePage  = lazy(() => import('components/ErrorsPage/InactivePage').then(m => ({ default: m.InactivePage })))

const LoadingFallback = () => <Loading2 />

export const standard = (language,start) => [
  { path:`:${language}`              , element:<Navigate to={start} replace/>, index:true },
  { path:`:${language}/isometry`     , element:<ViewIsometry/>  },
  { path:`:${language}/isometry/:sub`, element:<ViewIsometry/> },
  { path:`:${language}/gallery`      , element:<Suspense fallback={<LoadingFallback />}><ViewGallery/></Suspense>   },
  { path:`:${language}/downloads`    , element:<Suspense fallback={<LoadingFallback />}><ViewDownloads/></Suspense> },
  { path:`:${language}/list`         , element:<Suspense fallback={<LoadingFallback />}><ViewList/></Suspense>      }, 
  { path:`:${language}/compare`      , element:<Suspense fallback={<LoadingFallback />}><ViewCompare/></Suspense>   },
  { path:`:${language}/favorites`    , element:<Suspense fallback={<LoadingFallback />}><ViewFavorites/></Suspense> },
  { path:`:${language}/unit/:UnitID` , element:<Suspense fallback={<LoadingFallback />}><ViewUnit/></Suspense>      },
  { path:`:${language}/under-maintenance` , element:<Suspense fallback={<LoadingFallback />}><Maintenance/></Suspense>      },
  { path:`:${language}/inactive` , element:<Suspense fallback={<LoadingFallback />}><InactivePage /></Suspense>      }
]